import React, { FC, useEffect, useRef } from "react";
import { useBetBuilder } from "../providers/BetBuilderProvider";

const BetBuilder: FC = () => {
  const { mountWidget, unmountWidget } = useBetBuilder();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      mountWidget(containerRef.current);
    }

    return () => {
      unmountWidget();
    };
  }, []);

  return <div className="border-b border-solid border-betslip-border" ref={containerRef} />;
};

export default BetBuilder;
